var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("AirExport.NextLegEntry"),
        width: _vm.$selectByLang("400px", "430px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("100px", "130px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("AirExport.ActualFlight") } },
            [
              _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: { no: "1" },
                model: {
                  value: _vm.form.actualFlight,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "actualFlight", $$v)
                  },
                  expression: "form.actualFlight"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "ATD：" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "120px" },
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  clearable: "",
                  no: "2"
                },
                model: {
                  value: _vm.form.atd,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "atd", $$v)
                  },
                  expression: "form.atd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("AirExport.NextLegInformation") } },
            [
              _c("el-input", {
                staticStyle: { width: "284px" },
                attrs: { type: "textarea", rows: 6, no: "3" },
                model: {
                  value: _vm.form.onwardJourney,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "onwardJourney", $$v)
                  },
                  expression: "form.onwardJourney"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "4" },
              on: { click: _vm.okClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "5" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }